import React, { useMemo } from 'react';

import ProfileTimelineCard, { toSortTime } from './ProfileTimelineCard';

import { CARD_USER_EXPERIENCE } from '../../utils/constant/card';

const { EXPERIENCE } = CARD_USER_EXPERIENCE;

function ExperienceCard({ data, onClickEdit }) {
  const items = useMemo(
    () =>
      [...(data || [])]
        .sort((a, b) => toSortTime(b?.start) - toSortTime(a?.start))
        .map((experience, index) => ({
          key: experience?._id || index,
          title: experience?.companyName?.name,
          subtitle: experience?.title,
          start: experience?.start,
          end: experience?.end
        })),
    [data]
  );

  return (
    <ProfileTimelineCard
      title={EXPERIENCE}
      icon="bi-briefcase"
      itemIcon="bi-briefcase"
      items={items}
      emptyText="No experience details available."
      onClickEdit={onClickEdit}
    />
  );
}

export default ExperienceCard;
